<script setup lang="ts">
import type { HTMLAttributes } from 'vue';
import { reactiveOmit } from '@vueuse/core';
import { ChevronDown } from 'lucide-vue-next';
import { SelectIcon, SelectTrigger, type SelectTriggerProps, useForwardProps } from 'reka-ui';
import { cn } from '@/lib/utils';

const props = defineProps<SelectTriggerProps & { class?: HTMLAttributes['class'] }>();

const delegatedProps = reactiveOmit(props, 'class');

const forwardedProps = useForwardProps(delegatedProps);
</script>

<template>
  <SelectTrigger
    v-bind="forwardedProps"
    :class="
      cn(
        'tw-flex tw-h-9 tw-w-full tw-items-center tw-justify-between tw-whitespace-nowrap tw-rounded-md tw-border tw-border-neutral-200 tw-bg-neutral-200 tw-px-3 tw-py-2 tw-text-sm tw-shadow-sm tw-ring-offset-white data-[placeholder]:tw-text-neutral-500 focus:tw-outline-none focus:tw-ring-1 focus:tw-ring-neutral-950 disabled:tw-cursor-not-allowed disabled:tw-opacity-50 [&>span]:tw-truncate tw-text-start dark:tw-border-neutral-800 dark:tw-ring-offset-neutral-950 dark:data-[placeholder]:tw-text-neutral-400 dark:focus:tw-ring-neutral-300',
        props.class
      )
    "
  >
    <slot />
    <SelectIcon as-child>
      <ChevronDown class="tw-w-4 tw-h-4 tw-opacity-50 tw-shrink-0" />
    </SelectIcon>
  </SelectTrigger>
</template>
